import styled from 'styled-components';
import { theme } from 'styled-tools';

import BadgeIcon from '@ui/badgeIcon';
import { Icon } from '@ui/icons';

import { getRouteStepGlyph } from './routeStepIcons.ts';

export type RouteStepIconProps = {
  name?: string;
  size?: number;
};

// Categories without a theme token fall back to the walking colour.
const StepBadge = styled(BadgeIcon)<{ $colorToken: string }>`
  background-color: ${props => theme(props.$colorToken)(props) ?? theme('colors.primary')(props)};
`;

const TurnIcon = styled(Icon)`
  color: ${theme('colors.primary')};
`;

export default function RouteStepIcon({ name = '', size }: RouteStepIconProps) {
  const glyph = getRouteStepGlyph(name);
  if (glyph.turn) {
    return <TurnIcon name={glyph.name} width={size} height={size} aria-hidden="true" />;
  }

  return (
    <StepBadge
      name={glyph.name}
      size={size}
      $colorToken={glyph.colorToken}
      borderColor="transparent"
      aria-hidden="true"
    />
  );
}
